import { render } from "./ViewSessionReponsePage.vue?vue&type=template&id=25c5cd6c&ts=true"
import script from "./ViewSessionReponsePage.vue?vue&type=script&lang=ts"
export * from "./ViewSessionReponsePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__